import {
  Edit,
  SimpleForm,
  TextInput,
  Datagrid,
  List,
  TextField,
  Create,
  DateInput,
} from "react-admin";

export const PersonList = () => (
  <List>
    <Datagrid rowClick="edit">
      <TextField  label="First Name" source="firstName" />
      <TextField  label="Last Name" source="lastName" />
    </Datagrid>
  </List>
);

export const PersonCreate = () => (
  <Create>
    <SimpleForm>
      <TextInput  label="First Name" source="firstName" />
      <TextInput  label="Last Name" source="lastName" />
      <DateInput  label="Birthday" source="birthday" defaultValue={new Date('2000-01-01')}/>
      <TextInput  label="Email" source="primaryEmailAddress" />
    </SimpleForm>
  </Create>
  );

export const PersonEdit = () => (
  <Edit>
    <SimpleForm>
    <TextInput  label="First Name" source="firstName" />
      <TextInput  label="Last Name" source="lastName" />
      <DateInput  label="Birthday" source="birthday" defaultValue={new Date('2000-01-01')}/>
      <TextInput  label="Email" source="primaryEmailAddress" />
    </SimpleForm>
  </Edit>
);
